// Slugs do calculator-api (consumo via API B2B) → labels de produto.
// A lista cresce sem aviso no calculator-api: quem renderiza usa
// `labels[slug] ?? slug`, nunca assume que o slug está aqui.

export const calculatorSlugs = {
  trabalhista: "JusTrabalhista",
  completa: "JusCalc Completo",
  correction_simple: "JusCalc Fácil",
  divorcio: "JusCalc Divórcio",
  inss: "JusCalc INSS (Restituição)",
  superendividamento: "JusCalc Superendividamento",
  pasep: "JusCalc Revisão do PASEP",
  "progressao-regime": "JusCriminal Progressão de regime",
  aluguel: "JusCalc Aluguel",
  fgts: "JusCalc Correção do FGTS",
  dosimetria: "JusCriminal Dosimetria da pena",
  "pensao-alimenticia": "JusCalc Pensão",
  revisional: "JusRevisional",
  rmc: "JusCalc RMC e RCC INSS",
  // TODO: confirmar label com produto (o equivalente antigo `prev` era só "Prev")
  "previdenciaria-acima-teto": "Previdenciária acima do teto",
};

export const querySlugs = {
  "debitos-veiculares": "Débitos veiculares",
  cnh: "CNH",
  placa: "Placa",
  "dados-pessoais": "Dados pessoais",
  "dados-profissionais": "Dados profissionais",
  "imoveis-financiados": "Imóveis financiados",
  sociedades: "Sociedades",
  "imoveis-rurais": "Imóveis rurais",
  // as oito abaixo entraram no calculator-api em 08/2026
  "marcas-e-patentes": "Marcas e patentes",
  "grupo-economico": "Grupo econômico",
  "veiculos-por-proprietario": "Veículos por proprietário",
  "restricao-de-credito": "Restrição de crédito",
  "dados-empresa": "Dados da empresa",
  "situacao-cadastral-cpf": "Situação cadastral do CPF",
  relacionamentos: "Relacionamentos",
  // TODO: confirmar com produto os labels das quatro abaixo
  telefone: "Telefone",
  "localizacao-por-nome": "Localização por nome",
  "rastreamento-veicular": "Rastreamento veicular",
  "buscador-processual": "Buscador processual",
};

// Escopos fora das famílias por slug. TODO: confirmar os labels com produto.
export const standaloneScopeLabels = {
  "calculadoras.indices-correcao:read": "Índices de correção",
  "jus-score:execute": "JusScore",
};
